import styled from '@emotion/styled';
import { Button, Flex, Icon, Row } from 'common/styles';
import StaticText from 'common/StaticText';
import { __t } from 'common/i18n';
import StaticLayout from 'common/Layout/StaticLayout';
import { AgahSazan, Pargar } from '../common/icons';
import React from 'react';
import Seo from 'common/Seo';
import Breadcrumb from 'common/Breadcrumb';

export default function About() {
  return (
    <>
      <Seo
        title={`${__t('static_siteName')} | تبلیغات در فیلم‌نت`}
        description="اطلاعات و راهکارهای تبلیغات و همکاری تجاری در پلتفرم فیلمنت"
        path="/ads"
      />
      <Breadcrumb items={[
        { name: __t('common.home'), url: '/' },
        { name: 'تبلیغات در فیلم‌نت', url: '/ads' },
      ]} />
      <StaticLayout cover="/static/images/static_pages/ads.jpg" title={__t('static.ads.title')} subtitle={__t('static.ads.subtitle')}>
        <Row cols={{ xs: 1, md: 2 }} gap={{ xs: 2, md: 10 }} mt={{ xs: 2, md: 8 }}>
          <Flex direction="column">
            <Flex justify="center" align="center" mb={1}>
              <Icon size="larger">
                <AgahSazan />
              </Icon>
            </Flex>
            <CustomText variant="body2" mb={4}>{__t('static.ads.info.first')}</CustomText>
            <Row cols={{ xs: 1, md: 2 }}>
              <CustomButtonA fullWidth>021-47758</CustomButtonA>
              <CustomButtonA fullWidth onClick={() => {
                window.open('https://agahsazan.com/', '_blank');
              }}>AGAHSAZAN.COM</CustomButtonA>
            </Row>
          </Flex>
          <Flex direction="column">
            <Flex justify="center" align="center" mb={1}>
              <Icon size="larger">
                <Pargar />
              </Icon>
            </Flex>
            <CustomText variant="body2" mb={4}>{__t('static.ads.info.second')}</CustomText>
            <Row cols={{ xs: 1, md: 2 }}>
              <CustomButtonB fullWidth>021-43000480</CustomButtonB>
              <CustomButtonB fullWidth onClick={() => {
                window.open('https://pargar.co/', '_blank');
              }}>PARGAR.CO</CustomButtonB>
            </Row>
          </Flex>
        </Row>
        <Row cols={{ xs: 1, md: 4 }} mt={8}>
          <CustomButtonC fullWidth>Brand Placement</CustomButtonC>
          <CustomButtonC fullWidth>Product Placement</CustomButtonC>
          <CustomButtonC fullWidth>Sponsoring</CustomButtonC>
          <CustomButtonC fullWidth>Midroll, Pre roll</CustomButtonC>
        </Row>
      </StaticLayout>
    </>
  );
}

const CustomText = styled(StaticText)(() => ({
  lineHeight: '1.8',
}));

const CustomButtonA = styled(Button)(() => ({
  fontSize: '0.875rem !important',
  paddingTop: '0.75rem !important',
  background: '#F26522',
  '&:hover': {
    background: '#F2652280',
  },
}));

const CustomButtonB = styled(Button)(() => ({
  fontSize: '0.875rem !important',
  paddingTop: '0.75rem !important',
  background: '#242B66',
  color: '#fff',
  '&:hover': {
    background: '#242B6680',
  },
}));

const CustomButtonC = styled(Button)(() => ({
  fontSize: '0.875rem !important',
  paddingTop: '0.75rem !important',
  background: '#282828',
  color: '#8A8D8F',
  height: '3.5rem',
  borderRadius: '40px',
  '&:hover': {
    background: '#28282880',
  },
}));
